module.exports = __webpack_public_path__ + "img/Nackrosor_Harstena.e1dd0141.jpg";